<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <navbar :back_path="'/debenture?deben_id=' + deben_id" active_screen="debenture" />
        <!-- <div class="text-center" style="width: 100%; padding: 4px 50px; background-color: #fff">
            <label class="fs-20" style="font-weight: 600; margin: 0; color: #000 !important"> การจองชื้อหุ้นกู้ชุดใหม่ผ่านระบบออนไลน์ สำหรับสิทธิ 1</label>
        </div>
        <div style="width: 100%; padding: 16px; background-color: #fff">
            <label style="font-size: 16px; font-weight: 300; margin: 0; color: #000 !important">
                1. ท่านต้องได้สมัครใช้บริการ Internet Banking ของธนาคารนั้นแล้ว (เงื่อนไขเป็นไปตามแต่ละธนาคารกำหนด)<br />
                2. เลือกธนาคารเดียวกันกับธนาคารที่ท่านรับเงินต้นหุ้น
                {{ this.final_debenture[0] ? this.final_debenture[0].next_deben_code : '' }}
                หรือ กรณีไม่ใช่ธนาคารเดียวกัน จะต้องทำการยืนยัน การขอเปลี่ยนบัญชีรับเงินต้นหุ้นกู้ชุดเดิมในระบบธนาคาร จึงจะสามารถจองชื้อผ่านระบบออนไลน์ได้
            </label>
        </div>
        <div class="text-center" style="width: 100%">
            <div style="background-color: #fff">
                <template v-for="(v, k) in banklist">
                    <div :key="k" :style="{ width: $device == 'mobile' ? '50%' : '25%', display: 'inline-block', 'padding-top': '16px' }" @click="handleClickImage(v.link)">
                        <img :src="'/resources/images/logo-' + v.bank_abbr + '.png'" :style="{ width: $device == 'mobile' ? '50%' : '25%', margin: 0, 'vertical-align': 'unset' }" />
                        <label style="font-size: 16px; font-weight: 300; display: block">
                            {{ v.service_name }}
                        </label>
                    </div>
                </template>
            </div>
        </div>
        <div class="text-center" style="width: 100%; padding: 4px; background-color: #fff">
            <label style="font-size: 16px; font-weight: 300; margin: 0; color: #cc0000 !important"> (ผู้มีสิทธิจองชื้อหุ้นกู้ชุดใหม่เป็นผู้มีรายชื่อ </label>
            <label style="font-size: 16px; font-weight: 300; margin: 0; color: #cc0000 !important">
                ณ วันปิดสิทธิ
                {{ this.final_debenture[0] ? toMoment(this.final_debenture[0].final_date) : '' }})
            </label>
        </div> -->
        <div class="p-16 min-h-100vh">
            <div class="bg-white br-12">
                <div class="text-center p-16 bg-red btlr-btrr-12">
                    <span class="fs-20 fw-600 color-white" style="display: block">การจองชื้อหุ้นกู้ชุดใหม่</span>
                    <span class="fs-20 fw-600 color-white" style="display: block">ผ่านระบบออนไลน์</span>
                </div>
                <div class="text-center p-16">
                    <span class="fs-18 fw-600 red text-center">สำหรับสิทธิ 1</span>
                </div>
                <div style="width: 100%; border-bottom: 1px solid #dddddd" />
                <div class="text-center p-16">
                    <template v-for="(v, k) in banklist">
                        <div class="w-50" style="display: inline-block" :key="k" @click="handleClickImage(v.link)">
                            <img :src="'/resources/images/logo-' + v.bank_abbr + '.png'" :style="{ width: $device == 'mobile' ? '50%' : '25%', margin: 0, 'vertical-align': 'unset' }" />
                            <br />
                            <span class="fs-16 fw-600">
                                {{ v.service_name }}
                            </span>
                        </div>
                    </template>
                </div>
                <div style="width: 100%; border-bottom: 1px solid #dddddd" />
                <div class="p-16">
                    <span class="fs-18">
                        1. ท่านต้องได้สมัครใช้บริการ Internet Banking ของธนาคารนั้นแล้ว (เงื่อนไขเป็นไปตามแต่ละธนาคารกำหนด)
                        <br />
                        <br />
                        2. เลือกธนาคารเดียวกันกับธนาคารที่ท่านรับเงินต้นหุ้น
                        {{ this.final_debenture && this.final_debenture[0] && this.final_debenture[0].next_deben_code ? this.final_debenture[0].next_deben_code : '' }}
                        หรือ กรณีไม่ใช่ธนาคารเดียวกัน จะต้องทำการยืนยัน การขอเปลี่ยนบัญชีรับเงินต้นหุ้นกู้ชุดเดิมในระบบธนาคาร จึงจะสามารถจองชื้อผ่านระบบออนไลน์ได้
                    </span>
                </div>
                <div class="p-16">
                    <div class="p-16 text-center">
                        <span class="fs-16 fw-600 red">(ผู้มีสิทธิ์จองซื้อหุ้นกู้ชุดใหม่เป็นผู้มีรายชื่อ<br />ณ วันปิดสิทธิ์ 10 มกราคม 2565)</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
        <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
import moment from 'moment';
export default {
    /* computed: {
    loading() {
      return this.$store.state.user.loading;
    },
  }, */
    components: {
        navbar,
    },
    data: function () {
        return {
            getting_data: true,
            current_page: 0,
            slides: [],
            user: this.$store.state.user,
            deben_id: this.$route.query.deben_id,
            final_debenture: [],
            final_rights: [],
            banklist: [],
            deben_amount: 0,
            invest_amount: 0,
        };
    },
    mounted() {
        this._mounted();
    },
    methods: {
        moment,
        _mounted: function () {
            this.getFinalDebenture(() => this.getDebentureBanklist(() => (this.getting_data = false)));
        },
        getDebentureBanklist: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/debenture/banklist',
                    data: this.final_debenture[0] && this.final_debenture[0].company_code ? { company_code: this.final_debenture[0].company_code } : '',
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            this.banklist = res.bank_list;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        getFinalDebenture: function (callback = null) {
            var self = this;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/debenture/finaldebenture',
                    callback: (res) => {
                        if (res && res.result == 'complete') {
                            console.log('self.deben_id', self.deben_id);
                            this.final_debenture = res.final_debenture.filter(function (value) {
                                return value.deben_id == self.deben_id;
                            });
                            if (this.final_debenture.length) {
                                this.final_rights = this.final_debenture[0].final_rights;
                            }
                            this.final_rights.forEach((fr) => {
                                this.deben_amount += Number(fr.deben_amount);
                                this.invest_amount += Number(fr.invest_amount);
                            });
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        handleClickImage(link) {
            window.open(link, '_self');
        },
        handleSlideClick(dataset) {
            console.log(dataset.index, dataset.name);
        },
        handlePageChange(page) {
            this.current_page = page;
        },
        handleNext() {
            if (this.current_page < 2) {
                this.current_page = this.current_page + 1;
                this.$refs.carousel.goToPage(this.current_page);
            }
        },
        เงื่อนไขและข้อกำหนด() {
            console.log('เงื่อนไขและข้อกำหนด');
        },
        วิธีการใช้งาน() {
            console.log('วิธีการใช้งาน');
        },
        toMoment(date_unix) {
            return this.mtby(moment.unix(date_unix), 'LL');
        },
    },
};
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
<style scoped>
.dot {
    /* background-color: #808080;
  border: 1px solid #808080; */
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: inline-block;
    margin-left: 8px;
}
.slide {
    background-color: transparent;
    /* min-height: 75vh; */
    width: 100%;
    text-align: center;
    margin-top: 40px;
}
.image {
    width: 100%;
}
.section-icons {
    width: 100%;
    background-color: rgba(128, 128, 128, 0.5);
    padding: 20px 0;
}
.main-icon {
    width: 80px;
}
.pl-2 {
    padding-left: 2px !important;
}
/* @media (max-device-width: 413px) {
  .reward-image {
    width: 50%;
  }
}
@media (max-device-width: 374px) {
  .reward-image {
    width: 40%;
  }
} */
</style>
